<div class="d-flex align-items-center text-center error-page bg-danger pt-5 pb-4 h-100">
    <div class="row flex-grow">
        <div class="col-lg-8 mx-auto text-white">
            <div class="row align-items-center d-flex flex-row">
                <div class="col-lg-4 text-lg-right pr-lg-4">
                    <i class="fa fa-times-circle" style="font-size: 178px;"></i>
                </div>
                <div class="col-lg-8 error-page-divider text-lg-left pl-lg-4">
                    <h2>{{ 'cancel_payment' | localise }}</h2>
                    <h3 class="font-weight-light">{{ 'cancel_payment_description' | localise }}</h3>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-12 text-center mt-xl-2">
                    <a class="text-white font-weight-medium" routerLink="/dashboard">{{ 'back' | localise }}</a>
                </div>
            </div>
        </div>
    </div>
</div>
